import React, {useState} from 'react'
import { Chart } from "react-google-charts";
import { shadeDefault } from '../InsightsColors';
import { addChartAnnotations, mergeChartOptions, replaceTrailingZerosWithNull} from '../insights_functions';

const stackOptions = [
    { label: "No Stack", value: false },
    { label: "Stacked", value: true },
    { label: "Percent", value: "percent" }
];

const InsightColumnStackedGraphView =(props)=>{
    const {viewData, activeOption, onSelect, isDrillDownMode} = props;
    const currentOption = activeOption || viewData.DefaultOption;
    const [stackMode, setStackMode] = useState(false);

    if(viewData && viewData.ViewData[currentOption] && viewData.ViewData[currentOption].ChartData)
    {
        //console.log("layout response view", viewData.ViewData[currentOption].ChartData);
        const chartType = viewData.ChartConfig?.chartType || "ColumnChart";
        const defaultChartOptions = {
                            bar: { groupWidth: "75%" },
                            legend: { position: isDrillDownMode ? "top" : "top" },
                            hAxis: { title: viewData.X_AXIS_Title },
                            vAxis: { title: viewData.ViewData[currentOption].Y_AXIS_Title },
                            colors: shadeDefault,
                            isStacked: stackMode,
                            animation: {
                                duration: 1000,
                                easing: "out",
                            },
                        };
        const chartOptions = mergeChartOptions(defaultChartOptions, viewData.ChartConfig?.options);
        const rawData = viewData.ViewData[currentOption].ChartData;
        const normalizedChartData = replaceTrailingZerosWithNull(rawData);
        const chartData = addChartAnnotations(normalizedChartData, viewData.ChartConfig?.annotation);
        const chartFormatters = viewData.ChartConfig?.formatters || [];

        const chartEvents = onSelect ? [
            {
                eventName: "select",
                callback: ({ chartWrapper }) => {
                    const chart = chartWrapper.getChart();
                    const selection = chart.getSelection();
                    if (selection.length > 0) {
                        const { row, column } = selection[0];
                        // row: index of the data row (excluding header)
                        // column: index of the data column
                        const dataRow = chartData[row + 1]; // +1 because first row is header
                        const dataColName = chartData[0][column];
                        const value = dataRow ? dataRow[column] : null;
                        // Do something with row, column, value, dataColName, dataRow
                        onSelect({ row, column, value, dataColName, dataRow });
                    }
                }
            }
        ] : [];

        return (
            <>
                <div style={{height: "25px" }}>
                    {stackOptions.map(opt => (
                        <button
                            key={opt.value.toString()}
                            onClick={() => setStackMode(opt.value)}
                            className={'uiChip'}
                            style={{
                                marginRight: 8,
                                background: stackMode === opt.value ? "#0080ff" : "#f0f0f0",
                                color: stackMode === opt.value ? "#fff" : "#333",
                                border: "1px solid #ccc",
                                cursor: "pointer"
                            }}
                        >
                            {opt.label}
                        </button>
                    ))}
                </div>
                <div style={{height: "calc(100% - 25px)" }}>
                    <Chart
                        chartType={chartType}
                        data={chartData}
                        options={chartOptions}
                        formatters={chartFormatters}
                        chartEvents={chartEvents}
                        width="100%"
                        height="100%"
                    />
                </div>
            </>
        )
    }

    return null;
}

export default InsightColumnStackedGraphView

